'use client';

import { PropsWithChildren, useEffect } from 'react';
import useCurrentOrganisation from '@/hooks/studbook/useCurrentOrganisation';
import useStudbookContext from '@/studbook/store/useStudbookContext';
import usePublicSearchLimit from '@/components/publicSearch/HeroSection/usePublicSearchLimit';

export default function OrgNameLayout({ children }: PropsWithChildren) {
  const currentOrg = useCurrentOrganisation();
  const { setOrgId } = useStudbookContext();

  usePublicSearchLimit();

  // Synchronize orgId from URL params to studbook context
  useEffect(() => {
    if (currentOrg.orgId && currentOrg.hasOrgSpecified) {
      setOrgId(currentOrg.orgId);
    }
  }, [currentOrg.orgId, currentOrg.hasOrgSpecified, setOrgId]);

  return children;
}
